$(document).ready(function () {
	$("#register-form[data-lookup-route] #company_inn").on('blur', function () {
		let $form = $(this).closest('form');
		let inn = $(this).val();
		let route = $form.data('lookup-route');
		let params = {inn: inn};

		$.get(route, params, function (data) {
			if (!data.error) {
				$("#register-form #company_title").val(data.company.title);
				$("#register-form #company_kpp").val(data.company.kpp);
				$("#register-form #company_address").val(data.company.address);
			}
		});
	})
});
